import "./App.css";
import { MainContent } from "./components/MainContent/MainContent";
import { Navbar } from "./components/Navbar/Navbar";

function App() {
  return (
    <>
      <Navbar />
      <MainContent />
    </>
  );
}

export default App;
